import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ComprobanteStatus from '../../support/enum/ComprobanteStatus';
import ComprobanteCancelacionStatus from '../../support/enum/ComprobanteCancelacionStatus';

class ComprobantesItemStatus extends Component {

  get config() {
    const { data: { status } } = this.props;
    const { data: { cancelacion_status } } = this.props;

    const comprobante = ComprobanteStatus.search(status) || ComprobanteStatus.undefined();
    const cancelacion = ComprobanteCancelacionStatus.search(cancelacion_status) || ComprobanteStatus.undefined();

    let variant = 'success';
    let icon = 'circle';

    if (comprobante.isCancelling() || cancelacion.isProcessing()) {
      variant = 'warning';
      icon = 'clock';
    } else if (comprobante.isCancelled()) {
      variant = 'danger';
      icon = 'circle';
    }

    return {
      icon,
      variant
    }
  }

  render() {
    const { icon, variant } = this.config;

    return (
      <span className={ `badge-rounded text-${variant}` }>
        <FontAwesomeIcon icon={ ['fas', icon] } />
      </span>
    )
  }
}

export default ComprobantesItemStatus;